export function getsperdata(data) {
  //本体的关系数据
  var spe_rels = data.spedata.spe_rels;
  //本体的选项数据体的选项
  var spe_opt = data.spedata.spe_opt;
  //订货号数据货号数据
  var spe_order = data.spedata.spe_order;
  //本体的价格数据体的价格
  var spe_price = data.spedata.spe_price;
  //本体的层级数据体的层级
  var spe_prop = data.spedata.spe_prop;

  //从接口中 http:接口中 h
  var acc_opt = data.accdata.acc_opt;
  //附件的价格件的价格
  var acc_price = data.accdata.acc_price;
  //附件的层级件的层级
  var acc_prop = data.accdata.acc_prop;
  //附件的关系件的关系
  var acc_rels = data.accdata.acc_rels;
  //附件的分类数据件的分类
  var acc_type = data.accdata.acc_type;
  // console.log(acc_opt, acc_price, acc_prop, acc_rels, acc_type);

  //默认选中
  var defaultSelected = data.defaultSelected;
  var ShortName = data.ShortName;
  // var aeSelected = [{ ae: 702, ck: 1, select: [3, 5] }, { ae: 706, ck: 1, select: [3, 4] }]

  var aeSelected = data.acckey;

  //getData()
  //处理函数  getData()
  function getData() {
    let resultData = {};
    // 先把数据分类标号 可以减少匹配数据时候的循环数据
    //层级数据
    let PropDict = new Dictionary();
    for (let i = 0; i < spe_prop.length; i++) {
      PropDict.set(spe_prop[i].propId, spe_prop[i]);
    }
    //选项数据
    let OptDict = new Dictionary();
    for (let j = 0; j < spe_opt.length; j++) {
      OptDict.set(spe_opt[j].optId, spe_opt[j]);
    }
    //根据传入的数组数据 得到一个完整的选项数据
    let spe_select = getSelectDict(defaultSelected, PropDict, OptDict);
    //console.log(spe_select)
    //本体的层级数据 参数： 选中的选项,本体的层级的数据,本体选项的数据,本体的关系,选项组成的字典数据,系列的简称
    let spePropData = getProps(
      spe_select,
      spe_prop,
      spe_opt,
      spe_rels,
      OptDict,
      ShortName
    );
    //console.log(spePropData)
    //本体层级数据
    resultData.props = spePropData.get("PropData");
    //拼接显示的名字
    resultData.propName = spePropData.get("proPName");
    //去匹配本体订单号的名字
    let productOName = spePropData.get("proOName");
    if (!spe_order.length == 0) {
      //本体的订单号
      resultData.propOrder = getProductOrder(productOName, spe_order);
    } else {
      resultData.propOrder = "无订货号";
    }
    //去本体匹配价格
    let endSelect = spePropData.get("Selected");
    //console.log(endSelect)
    if (!spe_price.length == 0) {
      //价格数据
      let propPrice = getProductPrice(endSelect, spe_price);
      //赋值本体价格数据
      resultData.propPrice = propPrice.get("ProductPrice");
      //更新本体价格的时间
      resultData.time = propPrice.get("UpdateTime");
    } else {
      resultData.propPrice = "未定价";
      resultData.time = "";
    }

    //本体选中的 层级 和 选项名字(附件使用)
    let optSelectName = spePropData.get("ponameAcc");
    //处理附件的数据(去判断一下附件中是否有数据)
    if (!acc_type.length == 0) {
      //去匹配附件的数据 参数：本体选中的数据,附件分类数据,附件层级数据,附件的选项数据,附件的关系数据,附件的价格数据,订货号,附件选中状态的数据
      resultData.accData = getaccProduct(
        optSelectName,
        acc_type,
        acc_prop,
        acc_opt,
        acc_rels,
        acc_price,
        spe_order,
        aeSelected
      );
    } else {
      resultData.accData = [];
    }

    //整理出产品的清单  参数 本体的订单号名字 订货号 本体价格  附件的信息
    resultData.inventory = getinventory(
      spePropData.get("proOName"),
      resultData.propOrder,
      resultData.propPrice,
      resultData.accData
    );

    // console.log(resultData);
    return resultData;
  }

  //根据数据得到产品列表
  function getinventory(speOName, speOrder, spePrice, accData) {
    let inventoryData = [];
    let addSpe = {};
    addSpe.name = speOName;
    addSpe.order = speOrder;
    addSpe.price = spePrice;
    addSpe.main = true;
    inventoryData.push(addSpe);

    //判断一下附件是否有数据
    if (!accData.length == 0) {
      for (let i = 0; i < accData.length; i++) {
        let addChild = accData[i].child;
        for (let j = 0; j < addChild.length; j++) {
          if (addChild[j].selected) {
            let addAcc = {};

            addAcc.order = addChild[j].order;
            addAcc.orderNum = addChild[j].orderNum;
            addAcc.price = addChild[j].price;
            addAcc.main = false;
            inventoryData.push(addAcc);
          }
        }
      }
    }
    return inventoryData;
  }

  //根据附件的数据整合返回给函数
  function getaccProduct(
    SelectedOptName,
    acc_type,
    acc_prop,
    acc_opt,
    acc_rels,
    acc_price,
    spe_order,
    aeSelected
  ) {
    //创建字典把附件的数据分类
    //层级数据
    let aePropDict = new Dictionary();
    for (let i = 0; i < acc_prop.length; i++) {
      if (aePropDict.has(acc_prop[i].ae)) {
        aePropDict.get(acc_prop[i].ae).push(acc_prop[i]);
      } else {
        let addProp = [];
        addProp.push(acc_prop[i]);
        aePropDict.set(acc_prop[i].ae, addProp);
      }
    }
    //选项数据
    let aeoptDict = new Dictionary();
    for (let j = 0; j < acc_opt.length; j++) {
      if (aeoptDict.has(acc_opt[j].ae)) {
        aeoptDict.get(acc_opt[j].ae).push(acc_opt[j]);
      } else {
        let addOpt = [];
        addOpt.push(acc_opt[j]);
        aeoptDict.set(acc_opt[j].ae, addOpt);
      }
    }
    //价格
    let aePriceDict = new Dictionary();
    for (let k = 0; k < acc_price.length; k++) {
      aePriceDict.set(acc_price[k].ae, acc_price[k].data);
    }
    //关系
    let aeRelsDict = new Dictionary();
    for (let l = 0; l < acc_rels.length; l++) {
      aeRelsDict.set(acc_rels[l].ae, acc_rels[l].data);
    }
    //选中状态
    let aeckDict = new Dictionary();
    for (let p = 0; p < aeSelected.length; p++) {
      aeckDict.set(aeSelected[p].ae, aeSelected[p]);
    }

    //创建一个变量用来存储需要的附件
    let aeAddDict = new Dictionary();
    //得到全部的ae 用来循环处理数据
    let aeKeys = aePropDict.keys();
    for (let m = 0; m < aeKeys.length; m++) {
      //传入数据 处理单个附件的函数 参数：本体选中数据,附件层级,附件选项,附件价格,附件关系,订单号

      //可能ae附件 中无 aeRelsDict
      let getAccData = screenAcc(
        SelectedOptName,
        aePropDict.get(aeKeys[m]),
        aeoptDict.get(aeKeys[m]),
        aePriceDict.get(aeKeys[m]),
        aeRelsDict.get(aeKeys[m]),
        spe_order,
        aeckDict.get(aeKeys[m])
      );
      if (!getAccData == "") {
        getAccData.ae = aeKeys[m];
        aeAddDict.set(aeKeys[m], getAccData);
      }
    }

    let returnAccData = [];
    //遍历附件分类数据 判断数据是否在要添加的数据里
    for (let n = 0; n < acc_type.length; n++) {
      let addOneACC = {};
      addOneACC.typeId = acc_type[n].typeId;
      addOneACC.typeName = acc_type[n].typeName;
      addOneACC.child = [];
      for (let p = 0; p < acc_type[n].child.length; p++) {
        if (aeAddDict.has(acc_type[n].child[p].ae)) {
          aeAddDict.get(acc_type[n].child[p].ae).name =
            acc_type[n].child[p].typeName;
          addOneACC.child.push(aeAddDict.get(acc_type[n].child[p].ae));
        }
      }
      //需要判断一下 里面是否有附件的信息 没有就不要添加
      if (!addOneACC.child.length == 0) {
        returnAccData.push(addOneACC);
      }
    }
    //返回附件数据
    return returnAccData;
  }

  //根据传入的参数 处理单个附件的函数
  function screenAcc(
    Select,
    accProp,
    accOpt,
    accPrice,
    accRels,
    Order,
    aeckData
  ) {
    //prop的字典
    let accPropDict = new Dictionary();
    for (let i = 0; i < accProp.length; i++) {
      accPropDict.set(accProp[i].propId, accProp[i]);
    }
    //选项数据
    let accOptDict = new Dictionary();
    for (let i = 0; i < accOpt.length; i++) {
      accOptDict.set(accOpt[i].optId, accOpt[i]);
    }
    //确定附件选项 需要根据本体的关系来加载规则  并且要判断第一层规则 来控制这个附件的显示
    //定义一个字典 用于记住选项和层级
    let accSelectDict = new Dictionary();
    //去判断这个附件是否需要显示
    for (let i = 0; i < accProp.length; i++) {
      if (!accProp[i].saProp == 0) {
        for (let j = 0; j < accOpt.length; j++) {
          //判断一下是否都符合，符合就记录下来去加载规则
          if (
            accOpt[j].optName == Select.get(accProp[i].saProp) &&
            accOpt[j].propId == accProp[i].propId
          ) {
            accSelectDict.set(accOpt[j].propId, accOpt[j].optId);
          }
        }
      } else {
        for (let k = 0; k < accOpt.length; k++) {
          if (accOpt[k].propId == accProp[i].propId) {
            accSelectDict.set(accOpt[k].propId, accOpt[k].optId);
            break;
          }
        }
      }
    }
    //用来标记 用户是否选了附件 默认为2  0表示不选 1表示勾选
    let ckSelect = 2;
    //如果aeckData 有数据就不会是 undefined
    if (!(typeof aeckData == "undefined")) {
      ckSelect = aeckData.ck;
      for (let b = 0; b < aeckData.select.length; b++) {
        //更改选中的数据
        let accopt = accOptDict.get(aeckData.select[b]);
        accSelectDict.set(accopt.propId, accopt.optId);
      }
    }
    //得到选中的结果后 就要判断这个附件是否需要显示在页面上  判断这个附件是否需要显示 还是显示不打勾 还是禁用默认勾选
    let aeAddAcc = "N";
    if (typeof accRels == "undefined") {
      aeAddAcc = "Y";
    } else {
      //用一个变量来记录它是否加载过规则
      let hasRels = 1;
      let accSelectArr = accSelectDict.values();
      for (let k = 0; k < accRels.length; k++) {
        let accSplit = accRels[k].rels.split("|"); //分割出来的第二部分可能会存在 + 号
        if (accSplit[0] == 1) {
          //用一个变量来记录它是否加载过规则
          hasRels = 0;
          //用一个变量来判断是否符合这条规则
          let addAccRels = 1;
          let accRelsArr = accSplit[1].split("+");
          for (let l = 0; l < accRelsArr.length; l++) {
            //判断选中的字典中是否有这个数据
            if (!contains(accSelectArr, accRelsArr[l])) {
              addAccRels = 0;
              break;
            }
          }
          if (addAccRels == 1) {
            // 1表示禁用选中
            if (accRels[k].content.indexOf("1") != -1) {
              aeAddAcc = "D";
            }
            // 2表示不显示这个附件
            if (accRels[k].content.indexOf("2") != -1) {
              aeAddAcc = "N";
            }
            // 1,2 2,1 表示显示不勾选
            if (
              accRels[k].content.indexOf("1") != -1 &&
              accRels[k].content.indexOf("2") != -1
            ) {
              aeAddAcc = "Y";
            }
          }
        }
      }
      if (hasRels == 1) {
        aeAddAcc = "Y";
      }
    }
    if (aeAddAcc == "N") {
      return "";
    }
    //创建一个变量存储 根据附件选中的选项 加载规则得到层级数据  拼接名字 匹配订货号 匹配价格
    let returnAeData = {};
    //层级数据
    let accPropData = screenAccProp(
      accSelectDict,
      accProp,
      accOpt,
      accRels,
      accPropDict,
      accOptDict
    );
    returnAeData.props = accPropData.get("AccProp");
    //名字和订单号一样
    returnAeData.name = "";
    returnAeData.name2 = accPropData.get("accproPName");
    returnAeData.order = accPropData.get("accproOName");
    //匹配后的选项
    let endAccSelect = accPropData.get("AccSelect");
    //匹配附件的订货号
    returnAeData.orderNum = getProductOrder(returnAeData.order, Order);
    //根据选中的数据得到价格
    let accPropPice = getProductPrice(endAccSelect, accPrice);
    returnAeData.price = accPropPice.get("ProductPrice");
    returnAeData.time = accPropPice.get("UpdateTime");
    //判断选中还是不选中
    if (aeAddAcc == "D") {
      returnAeData.selected = true;
      returnAeData.disabled = true;
    }

    if (aeAddAcc == "Y") {
      returnAeData.disabled = false;
      if (ckSelect == 1) {
        returnAeData.selected = true;
      } else {
        returnAeData.selected = false;
      }
    }
    return returnAeData;
  }

  //根据单个附件的数据 筛选出附件的层级数据
  function screenAccProp(
    accSelectDict,
    accProp,
    accOpt,
    accRels,
    accPropDict,
    accOptDict
  ) {
    //创建一个变量用于存储数据
    let accPropData = [];
    //存储名字
    let accPNameDict = new Dictionary();
    let accONameDict = new Dictionary();
    //把accOpt的数据分类
    let optDict = new Dictionary();
    for (let i = 0; i < accOpt.length; i++) {
      if (optDict.has(accOpt[i].propId)) {
        optDict.get(accOpt[i].propId).push(accOpt[i]);
      } else {
        let addOpt = [];
        addOpt.push(accOpt[i]);
        optDict.set(accOpt[i].propId, addOpt);
      }
    }
    //显示排序字典
    let acclaySortDict = new Dictionary();
    //层级id和名字字典
    let namePropDict = new Dictionary();

    for (let j = 0; j < accProp.length; j++) {
      acclaySortDict.set(accProp[j].laySort, accProp[j].propId);
      namePropDict.set(accProp[j].propId, accProp[j].propName);
    }

    let PropSort = acclaySortDict.keys();
    for (let k = 0; k < PropSort.length; k++) {
      //循环一次要添加的值
      let addProp = {};
      addProp.propId = acclaySortDict.get(PropSort[k]);
      addProp.propName = namePropDict.get(addProp.propId);
      addProp.child = [];
      let addChild = optDict.get(acclaySortDict.get(PropSort[k]));
      //加载规则
      let addOptArr = [];
      if (!(typeof accRels == "undefined")) {
        for (let m = 0; m < accRels.length; m++) {
          let accSplit = accRels[m].rels.split("|"); //分割出来的第二部分可能会存在 + 号
          if (accSplit[0] == addProp.propId) {
            //用一个变量来判断是否符合这条规则
            let addAccRels = 1;
            let accRelsArr = accSplit[1].split("+");
            for (let n = 0; n < accRelsArr.length; n++) {
              //判断选中的字典中是否有这个数据
              if (!accSelectDict.hasvalues(accRelsArr[n])) {
                addAccRels = 0;
                break;
              }
            }
            if (addAccRels == 1) {
              addOptArr = accRels[m].content.split(",");
            }
          }
        }
      }
      for (let q = 0; q < addChild.length; q++) {
        if (addOptArr.length == 0 || contains(addOptArr, addChild[q].optId)) {
          let addOpt = {};
          addOpt.optId = addChild[q].optId;
          addOpt.optName = addChild[q].optName;
          if (accSelectDict.hasvalues(addOpt.optId)) {
            addOpt.select = true;
            //拼接名字
            if (accPropDict.get(addProp.propId).nameShow == 1) {
              accPNameDict.set(
                accPropDict.get(addProp.propId).nameSort,
                accOptDict.get(addOpt.optId).nameStr
              );
            }
            //拼接订单号名字
            if (accPropDict.get(addProp.propId).orderShow == 1) {
              accONameDict.set(
                accPropDict.get(addProp.propId).orderSort,
                accOptDict.get(addOpt.optId).orderStr
              );
            }
          } else {
            addOpt.select = false;
          }
          addProp.child.push(addOpt);
        }
      }
      //要判断一下是否有附件是有选中的数据 没有需要添加一个默认的选项 判断一下是否有true
      let hasTrue = 0;
      for (let w = 0; w < addProp.child.length; w++) {
        if (addProp.child[w].select) {
          hasTrue = 1;
          break;
        }
      }
      //表示要给一个默认的选项
      if (hasTrue == 0) {
        addProp.child[0].select = true;
        //修改数据 accSelectDict
        accSelectDict.set(addProp.propId, addProp.child[0].optId);
        //拼接名字
        if (accPropDict.get(addProp.propId).nameShow == 1) {
          accPNameDict.set(
            accPropDict.get(addProp.propId).nameSort,
            accOptDict.get(addProp.child[0].optId).nameStr
          );
        }
        //拼接订单号名字
        if (accPropDict.get(addProp.propId).orderShow == 1) {
          accONameDict.set(
            accPropDict.get(addProp.propId).orderSort,
            accOptDict.get(addProp.child[0].optId).orderStr
          );
        }
      }
      //判断一下 显示还是不显示
      if (accPropDict.get(addProp.propId).layShow == 1) {
        if (addProp.child.length == 1) {
          if (!(addProp.child[0].optName == "null")) {
            accPropData.push(addProp);
          }
        } else {
          accPropData.push(addProp);
        }
      }
    }
    //整合数据 返回数据
    let reAccData = new Dictionary();
    //层级数据
    reAccData.set("AccProp", accPropData);
    //选中的选项数
    reAccData.set("AccSelect", accSelectDict);
    //名字数据
    let accproPName = "";
    let accproOName = "";
    let nameKeys = accPNameDict.keys();
    for (let m = 0; m < nameKeys.length; m++) {
      accproPName += accPNameDict.get(nameKeys[m]);
    }
    let onameKeys = accONameDict.keys();
    for (let n = 0; n < onameKeys.length; n++) {
      accproOName += accONameDict.get(onameKeys[n]);
    }
    reAccData.set("accproPName", accproPName);
    reAccData.set("accproOName", accproOName);

    return reAccData;
  }

  //根据选中的选项 查找到价格
  function getProductPrice(endSelect, Price) {
    let ProductPrice = 0;
    let UpdateTime = "";
    let endValues = endSelect.values();
    // console.log(Price);
    if (Price !== undefined) {
      for (let i = 0; i < Price.length; i++) {
        let optArr = Price[i].optStr.split("-");
        let addprice = 1;
        for (let j = 0; j < optArr.length; j++) {
          // 判断值是否在键里面
          if (!contains(endValues, optArr[j])) {
            addprice = 0;
            break;
          }
        }
        if (addprice == 1) {
          ProductPrice = Price[i].compPrice;
          UpdateTime = Price[i].AddTime;
          break;
        }
      }
    }
    let priceRETDict = new Dictionary();
    priceRETDict.set("ProductPrice", ProductPrice);
    priceRETDict.set("UpdateTime", UpdateTime);
    return priceRETDict;
  }

  //根据拼接的名字和订货号数据 匹配
  function getProductOrder(proOName, spe_order) {
    let orderNum = "无订货号";
    for (let i = 0; i < spe_order.length; i++) {
      if (spe_order[i].speName == proOName) {
        orderNum = spe_order[i].orderNum;
        break;
      }
    }
    return orderNum;
  }

  //根据选中的数据得到本体层级数据
  function getProps(
    spe_select,
    spe_prop,
    spe_opt,
    spe_rels,
    OptDict,
    ShortName
  ) {
    //创建一个变量 用来存储本体层级数据
    let PropData = [];
    //存储名字
    let nameDict = new Dictionary();
    let orderDict = new Dictionary();
    //存储选中的opt名字和层级(附件显示的时候会用到)
    let ponameAcc = new Dictionary();

    //添加数据的时候需要按照排序的顺序添加 先创建一个字典存入排序数据
    let proplaySortDict = new Dictionary();
    for (let i = 0; i < spe_prop.length; i++) {
      proplaySortDict.set(spe_prop[i].laySort, spe_prop[i]);
    }

    //把spe_opt的数据分类创建一个字典
    let optPropId = new Dictionary();
    for (let a = 0; a < spe_opt.length; a++) {
      //判断一下是不是第一次添加
      if (optPropId.has(spe_opt[a].propId)) {
        optPropId.get(spe_opt[a].propId).push(spe_opt[a]);
      } else {
        let addArr = [];
        addArr.push(spe_opt[a]);
        optPropId.set(spe_opt[a].propId, addArr);
      }
    }

    //得到全部的键
    let PropSort = proplaySortDict.keys();
    for (let j = 0; j < PropSort.length; j++) {
      //循环一次要添加的值
      let addProp = {};
      //通过key得到值
      let addData = proplaySortDict.get(PropSort[j]);
      //添加数据
      addProp.propId = addData.propId;
      addProp.propName = addData.propName;
      //层级下面的选项数据
      addProp.child = [];

      //先要去匹配规则 再添加层级的数据 需要是数组 是字符串可能就有问题
      let addOptArr = [];
      //匹配关系数据
      for (let k = 0; k < spe_rels.length; k++) {
        let speSplit = spe_rels[k].rels.split("|");
        //判断一下是不是这一层的规则
        if (speSplit[0] == addProp.propId) {
          let addSpeRels = 1;
          let speRelsArr = speSplit[1].split("+");
          for (let l = 0; l < speRelsArr.length; l++) {
            //判断选中的字典中是否有这个数据
            if (!spe_select.hasvalues(speRelsArr[l])) {
              addSpeRels = 0;
              break;
            }
          }
          if (addSpeRels == 1) {
            addOptArr = spe_rels[k].content.split(",");
            break;
          }
        }
      }
      //添加选项数据 存入字典排序显示
      let optlaySortDict = new Dictionary();
      let opt_prop = optPropId.get(addProp.propId);
      for (let m = 0; m < opt_prop.length; m++) {
        optlaySortDict.set(opt_prop[m].showOrder, opt_prop[m]);
      }
      //得到全部的键
      let optlaySortKey = optlaySortDict.keys();
      for (let n = 0; n < optlaySortKey.length; n++) {
        let addChildSort = optlaySortDict.get(optlaySortKey[n]);
        if (addOptArr.length == 0 || contains(addOptArr, addChildSort.optId)) {
          let addOpt = {};
          addOpt.optId = addChildSort.optId;
          addOpt.optName = addChildSort.optName;
          //添加选中还是不选中的数据
          if (spe_select.hasvalues(addOpt.optId)) {
            addOpt.select = true;
            // 判断一下 添加名字和订货号名字  和附件的要用到的选中数据
            //先要判断一下是否要添加 名字 键 排序  值 名字
            if (addData.nameShow == 1) {
              nameDict.set(addData.nameSort, addChildSort.nameStr);
            }
            //判断一下是否要添加 订货号 键 排序  值 名字
            if (addData.orderShow == 1) {
              orderDict.set(addData.orderSort, addChildSort.orderStr);
            }
            //直接添加到本体选中的选项 键 层级 值 选项内容
            ponameAcc.set(addData.propId, addChildSort.optName);
          } else {
            addOpt.select = false;
          }
          addProp.child.push(addOpt);
        }
      }
      // 判断一下是否有true
      let hasTrue = 0;
      for (let w = 0; w < addProp.child.length; w++) {
        if (addProp.child[w].select) {
          hasTrue = 1;
          break;
        }
      }
      //表示要给一个默认的选项
      if (hasTrue == 0) {
        addProp.child[0].select = true;
        //修改选中的数据 把值给更改
        spe_select.set(addProp.propId, addProp.child[0].optId);
        // 同样要添加 名字 订货号名字  附件用到的选项
        let addChild = OptDict.get(addProp.child[0].optId);
        //先要判断一下是否要添加 名字 键 排序  值 名字
        if (addData.nameShow == 1) {
          nameDict.set(addData.nameSort, addChild.nameStr);
        }
        //判断一下是否要添加 订货号 键 排序  值 名字
        if (addData.orderShow == 1) {
          orderDict.set(addData.orderSort, addChild.orderStr);
        }
        //直接添加到本体选中的选项 键 层级 值 选项内容
        ponameAcc.set(addData.propId, addChild.optName);
      }
      // if (addData.layShow == 1) {
      //     PropData.push(addProp)
      // }

      if (addData.layShow == 1) {
        //判断一下是不是只有一个值 并且值为null 或者 0 无附件 就不要这一层
        if (addProp.child.length == 1) {
          if (
            !(
              addProp.child[0].optName == "null" ||
              addProp.child[0].optName == "0 无附件" ||
              addProp.child[0].optName == ""
            )
          ) {
            PropData.push(addProp);
          }
        } else {
          PropData.push(addProp);
        }
      }
    }
    //整合数据 把产品名字 订货号名字 不要显示的数据 和 当前层级和选项数据 和最后选中的数据 返回
    let reData = new Dictionary();
    //层级数据
    reData.set("PropData", PropData);
    //选用数据
    reData.set("Selected", spe_select);
    //名字数据的处理
    let proPName = "" + ShortName;
    let proOName = "" + ShortName;
    let nameKeys = nameDict.keys();
    for (let m = 0; m < nameKeys.length; m++) {
      proPName += nameDict.get(nameKeys[m]);
    }
    let onameKeys = orderDict.keys();
    for (let n = 0; n < onameKeys.length; n++) {
      proOName += orderDict.get(onameKeys[n]);
    }
    reData.set("proPName", proPName);
    reData.set("proOName", proOName);
    reData.set("ponameAcc", ponameAcc);

    return reData;
  }

  //根据选中的数据 返回一个字典
  function getSelectDict(defaultSelected, PropDict, OptDict) {
    //先从PropDict中得到默认的选项 再循环传过来的参数替换数据
    let getselect = new Dictionary();
    let PropKeys = PropDict.keys();
    for (let i = 0; i < PropKeys.length; i++) {
      getselect.set(PropKeys[i], PropDict.get(PropKeys[i]).defaultSelected);
    }

    for (let j = 0; j < defaultSelected.length; j++) {
      getselect.set(OptDict.get(defaultSelected[j]).propId, defaultSelected[j]);
    }
    return getselect;
  }

  //判断数组是否包含
  function contains(arr, obj) {
    let i = arr.length;
    while (i--) {
      if (arr[i] === obj || arr[i] === obj + "" || arr[i] + "" === obj) {
        return true;
      }
    }
    return false;
  }

  //封装字典类
  function Dictionary() {
    //字典属性
    this.items = {};
    //字典操作方法
    //在字典中添加键值对
    Dictionary.prototype.set = function(key, value) {
      this.items[key] = value;
    };
    //判断字典中是否有某个key
    Dictionary.prototype.has = function(key) {
      return this.items.hasOwnProperty(key);
    };
    //从字典中移除元素
    Dictionary.prototype.remove = function(key) {
      //1.判断字典中是否有这个key
      if (!this.has(key)) return false;

      //2.从字典中删除key
      delete this.items[key];
      return true;
    };
    //根据key获取value
    Dictionary.prototype.get = function(key) {
      return this.has(key) ? this.items[key] : undefined;
    };
    //获取所有keys
    Dictionary.prototype.keys = function() {
      return Object.keys(this.items);
    };
    //size方法
    Dictionary.prototype.size = function() {
      return this.keys().length;
    };
    //clear方法
    Dictionary.prototype.clear = function() {
      this.items = {};
    };

    //新增的函数
    //获取所有的value
    Dictionary.prototype.values = function() {
      return Object.values(this.items);
    };
    //判断是否有这个值
    Dictionary.prototype.hasvalues = function(v) {
      return contains(Object.values(this.items), v);
    };
  }

  return getData();
}
